
import React from 'react';
import { LogoUploadSection } from '../logo/LogoUploadSection';
import { PreviewSection } from '../logo/PreviewSection';
import { LogoLayout } from '../logo/useLogoUpload';
import { Business } from '@/data/types/businessTypes';

interface LogoTabProps {
  business: Business;
  logoPreview: string | null;
  uploadError: string | null;
  previewTab: string;
  setPreviewTab: (tab: string) => void;
  logoLayout: LogoLayout;
  setLogoLayout: (layout: LogoLayout) => void;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSaveLogo: () => void;
  handleReset: () => void;
  handleRemoveLogo: () => void;
}

export const LogoTab: React.FC<LogoTabProps> = ({
  business,
  logoPreview,
  uploadError,
  previewTab,
  setPreviewTab,
  logoLayout,
  setLogoLayout,
  handleFileChange,
  handleSaveLogo,
  handleReset,
  handleRemoveLogo
}) => {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left side: Upload section */}
        <div className="space-y-6">
          <LogoUploadSection 
            logoPreview={logoPreview}
            uploadError={uploadError}
            logoLayout={logoLayout}
            setLogoLayout={setLogoLayout}
            handleFileChange={handleFileChange}
            handleRemoveLogo={handleRemoveLogo}
            handleReset={handleReset}
          />
        </div>
        
        {/* Right side: Preview section */}
        <div>
          <PreviewSection 
            business={business}
            logoPreview={logoPreview}
            logoLayout={logoLayout}
            previewTab={previewTab}
            setPreviewTab={setPreviewTab}
          />
        </div>
      </div>
    </div>
  );
};
